// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file needsyou/needsyou.proto (package lvdr.v2.needsyou, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file needsyou/needsyou.proto.
 */
export const file_needsyou_needsyou: GenFile = /*@__PURE__*/
  fileDesc("ChduZWVkc3lvdS9uZWVkc3lvdS5wcm90bxIQbHZkci52Mi5uZWVkc3lvdSIVChNOZWVkc1lvdUxpc3RSZXF1ZXN0Il8KFE5lZWRzWW91TGlzdFJlc3BvbnNlEi0KBWl0ZW1zGAEgAygLMh4ubHZkci52Mi5uZWVkc3lvdS5OZWVkc1lvdUl0ZW0SGAoQZGVncmFkZWRfc291cmNlcxgCIAMoCSLwAQoMTmVlZHNZb3VJdGVtEgoKAmlkGAEgASgJEgwKBGtpbmQYAiABKAkSDQoFdGl0bGUYAyABKAkSDgoGZGV0YWlsGAQgASgJEgwKBGxpbmsYBSABKAkSGgoSY3JlYXRlZF9hdF91bml4X21zGAYgASgDEhoKEmV4cGlyZXNfYXRfdW5peF9tcxgHIAEoAxIuCgVzdGF0ZRgIIAEoDjIfLmx2ZHIudjIubmVlZHN5b3UuTmVlZHNZb3VTdGF0ZRIxCgdhY3Rpb25zGAkgAygLMiAubHZkci52Mi5uZWVkc3lvdS5OZWVkc1lvdUFjdGlvbiIrCg5OZWVkc1lvdUFjdGlvbhIKCgJpZBgBIAEoCRINCgVzdHlsZRgCIAEoCSI0ChZOZWVkc1lvdVJlc29sdmVSZXF1ZXN0EgoKAmlkGAEgASgJEg4KBmFjdGlvbhgCIAEoCSJZChdOZWVkc1lvdVJlc29sdmVSZXNwb25zZRIKCgJpZBgBIAEoCRIyCgdvdXRjb21lGAIgASgOMiEubHZkci52Mi5uZWVkc3lvdS5OZWVkc1lvdU91dGNvbWUiFgoUTmVlZHNZb3VDaGFuZ2VkRXZlbnQqagoNTmVlZHNZb3VTdGF0ZRIfChtORUVEU19ZT1VfU1RBVEVfVU5TUEVDSUZJRUQQABIbChdORUVEU19ZT1VfU1RBVEVfUEVORElORxABEhsKF05FRURTX1lPVV9TVEFURV9FWFBJUkVEEAIq0AEKD05lZWRzWW91T3V0Y29tZRIhCh1ORUVEU19ZT1VfT1VUQ09NRV9VTlNQRUNJRklFRBAAEh4KGk5FRURTX1lPVV9PVVRDT01FX1JFU09MVkVEEAESHgoaTkVFRFNfWU9VX09VVENPTUVfQ09ORkxJQ1QQAhIdChlORUVEU19ZT1VfT1VUQ09NRV9FWFBJUkVEEAMSHwobTkVFRFNfWU9VX09VVENPTUVfTk9UX0ZPVU5EEAQSGgoWTkVFRFNfWU9VX09VVENPTUVfQlVTWRAFQilaJ2dpdGh1Yi5jb20vZ3ZzNDIvbHZkci9wcm90by92Mi9uZWVkc3lvdWIGcHJvdG8z");

/**
 * @generated from message lvdr.v2.needsyou.NeedsYouListRequest
 */
export type NeedsYouListRequest = Message<"lvdr.v2.needsyou.NeedsYouListRequest"> & {
};

/**
 * Describes the message lvdr.v2.needsyou.NeedsYouListRequest.
 * Use `create(NeedsYouListRequestSchema)` to create a new message.
 */
export const NeedsYouListRequestSchema: GenMessage<NeedsYouListRequest> = /*@__PURE__*/
  messageDesc(file_needsyou_needsyou, 0);

/**
 * @generated from message lvdr.v2.needsyou.NeedsYouListResponse
 */
export type NeedsYouListResponse = Message<"lvdr.v2.needsyou.NeedsYouListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.needsyou.NeedsYouItem items = 1;
   */
  items: NeedsYouItem[];

  /**
   * Sources that could not be read. "Could not read" and "nothing pending" stay
   * different values up to the screen.
   *
   * @generated from field: repeated string degraded_sources = 2;
   */
  degradedSources: string[];
};

/**
 * Describes the message lvdr.v2.needsyou.NeedsYouListResponse.
 * Use `create(NeedsYouListResponseSchema)` to create a new message.
 */
export const NeedsYouListResponseSchema: GenMessage<NeedsYouListResponse> = /*@__PURE__*/
  messageDesc(file_needsyou_needsyou, 1);

/**
 * @generated from message lvdr.v2.needsyou.NeedsYouItem
 */
export type NeedsYouItem = Message<"lvdr.v2.needsyou.NeedsYouItem"> & {
  /**
   * "<source>:<opaque>", stable while the ask is pending
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * open string set
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string detail = 4;
   */
  detail: string;

  /**
   * app-relative deep link to the source surface
   *
   * @generated from field: string link = 5;
   */
  link: string;

  /**
   * @generated from field: int64 created_at_unix_ms = 6;
   */
  createdAtUnixMs: bigint;

  /**
   * 0 = does not expire
   *
   * @generated from field: int64 expires_at_unix_ms = 7;
   */
  expiresAtUnixMs: bigint;

  /**
   * @generated from field: lvdr.v2.needsyou.NeedsYouState state = 8;
   */
  state: NeedsYouState;

  /**
   * @generated from field: repeated lvdr.v2.needsyou.NeedsYouAction actions = 9;
   */
  actions: NeedsYouAction[];
};

/**
 * Describes the message lvdr.v2.needsyou.NeedsYouItem.
 * Use `create(NeedsYouItemSchema)` to create a new message.
 */
export const NeedsYouItemSchema: GenMessage<NeedsYouItem> = /*@__PURE__*/
  messageDesc(file_needsyou_needsyou, 2);

/**
 * @generated from message lvdr.v2.needsyou.NeedsYouAction
 */
export type NeedsYouAction = Message<"lvdr.v2.needsyou.NeedsYouAction"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * "primary" | "default" | "danger"
   *
   * @generated from field: string style = 2;
   */
  style: string;
};

/**
 * Describes the message lvdr.v2.needsyou.NeedsYouAction.
 * Use `create(NeedsYouActionSchema)` to create a new message.
 */
export const NeedsYouActionSchema: GenMessage<NeedsYouAction> = /*@__PURE__*/
  messageDesc(file_needsyou_needsyou, 3);

/**
 * @generated from message lvdr.v2.needsyou.NeedsYouResolveRequest
 */
export type NeedsYouResolveRequest = Message<"lvdr.v2.needsyou.NeedsYouResolveRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string action = 2;
   */
  action: string;
};

/**
 * Describes the message lvdr.v2.needsyou.NeedsYouResolveRequest.
 * Use `create(NeedsYouResolveRequestSchema)` to create a new message.
 */
export const NeedsYouResolveRequestSchema: GenMessage<NeedsYouResolveRequest> = /*@__PURE__*/
  messageDesc(file_needsyou_needsyou, 4);

/**
 * @generated from message lvdr.v2.needsyou.NeedsYouResolveResponse
 */
export type NeedsYouResolveResponse = Message<"lvdr.v2.needsyou.NeedsYouResolveResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: lvdr.v2.needsyou.NeedsYouOutcome outcome = 2;
   */
  outcome: NeedsYouOutcome;
};

/**
 * Describes the message lvdr.v2.needsyou.NeedsYouResolveResponse.
 * Use `create(NeedsYouResolveResponseSchema)` to create a new message.
 */
export const NeedsYouResolveResponseSchema: GenMessage<NeedsYouResolveResponse> = /*@__PURE__*/
  messageDesc(file_needsyou_needsyou, 5);

/**
 * Unsolicited; carries no count, the client refetches.
 *
 * @generated from message lvdr.v2.needsyou.NeedsYouChangedEvent
 */
export type NeedsYouChangedEvent = Message<"lvdr.v2.needsyou.NeedsYouChangedEvent"> & {
};

/**
 * Describes the message lvdr.v2.needsyou.NeedsYouChangedEvent.
 * Use `create(NeedsYouChangedEventSchema)` to create a new message.
 */
export const NeedsYouChangedEventSchema: GenMessage<NeedsYouChangedEvent> = /*@__PURE__*/
  messageDesc(file_needsyou_needsyou, 6);

/**
 * @generated from enum lvdr.v2.needsyou.NeedsYouState
 */
export enum NeedsYouState {
  /**
   * @generated from enum value: NEEDS_YOU_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NEEDS_YOU_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: NEEDS_YOU_STATE_EXPIRED = 2;
   */
  EXPIRED = 2,
}

/**
 * Describes the enum lvdr.v2.needsyou.NeedsYouState.
 */
export const NeedsYouStateSchema: GenEnum<NeedsYouState> = /*@__PURE__*/
  enumDesc(file_needsyou_needsyou, 0);

/**
 * @generated from enum lvdr.v2.needsyou.NeedsYouOutcome
 */
export enum NeedsYouOutcome {
  /**
   * @generated from enum value: NEEDS_YOU_OUTCOME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NEEDS_YOU_OUTCOME_RESOLVED = 1;
   */
  RESOLVED = 1,

  /**
   * someone resolved it first
   *
   * @generated from enum value: NEEDS_YOU_OUTCOME_CONFLICT = 2;
   */
  CONFLICT = 2,

  /**
   * @generated from enum value: NEEDS_YOU_OUTCOME_EXPIRED = 3;
   */
  EXPIRED = 3,

  /**
   * @generated from enum value: NEEDS_YOU_OUTCOME_NOT_FOUND = 4;
   */
  NOT_FOUND = 4,

  /**
   * Another approve or resume of the same run is in flight; nothing was decided.
   * Distinct from CONFLICT so the page can say "in progress", not "already handled".
   *
   * @generated from enum value: NEEDS_YOU_OUTCOME_BUSY = 5;
   */
  BUSY = 5,
}

/**
 * Describes the enum lvdr.v2.needsyou.NeedsYouOutcome.
 */
export const NeedsYouOutcomeSchema: GenEnum<NeedsYouOutcome> = /*@__PURE__*/
  enumDesc(file_needsyou_needsyou, 1);

